import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import WidgetOpeningSlider from 'modules/shared/widgets/components/widget-opening/components/widget-opening-slider';
import BannerInterface from 'modules/shared/layout/menu/components/menu-banner/banner.interface';
import { WidgetOpeningDataItem } from 'modules/shared/widgets/interfaces/widgets-data/widget-opening-data.interface';
import WidgetDSATitle from 'modules/shared/widgets/components/widget-dsa/components/widget-dsa-title/widget-dsa-title';
import { showDSA } from 'modules/shared/widgets/components/widget-dsa/helpers/dsa-helpers';

import './menu-banner.scss';

interface MenuBannerProps {
    bannerItems: BannerInterface[];
}

const MenuBanner: React.FC<MenuBannerProps> = ({ bannerItems }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    if (!bannerItems.length) {
        return null;
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div className="menu-banner" data-section="menu-banner">
            <div className="menu-banner__title">Polecamy</div>
            <div className="menu-banner__container">
                {bannerItems.length === 1
                    ? (
                        <>
                            {bannerItems[0].dsa && showDSA(bannerItems[0].dsa) && (
                                <div className="menu-banner__dsa">
                                    <WidgetDSATitle dsa={bannerItems[0].dsa} />
                                </div>
                            )}
                            <a
                                href={bannerItems[0].url}
                                title={bannerItems[0].title}
                                target={bannerItems[0].target ?? void 0}
                            >
                                <img
                                    className="menu-banner__image"
                                    src={isMobile ? bannerItems[0].mobileImage : bannerItems[0].image}
                                    alt={bannerItems[0].title}
                                />
                            </a>
                        </>
                    )
                    : (
                        <WidgetOpeningSlider
                            autoPlay={bannerItems.length > 1}
                            banner={bannerItems.map(({ url, target, title, image, mobileImage }) => ({
                                url,
                                target,
                                alt: title,
                                img: isMobile ? mobileImage : image
                            }) as WidgetOpeningDataItem)}
                            isMobile={isMobile}
                        />
                    )}
            </div>
        </div>
    );
};

export default MenuBanner;
